import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createRsaaOrDownloadFileTypes, createHeaders } from './actionHelpers';
import queryString from 'query-string';

const REPORTS_EARNINGS = 'REPORTS_EARNINGS';
const REPORTS_NEW_ACTORS = 'REPORTS_NEW_ACTORS';
const REPORTS_KPIS = 'REPORTS_KPIS';
const REPORTS_BOOKING_BOUNDARIES = 'REPORTS_BOOKING_BOUNDARIES';
const REPORTS_TRANSACTIONS = 'REPORTS_TRANSACTIONS';
const REPORTS_BOOKING_OVERVIEW = 'REPORTS_BOOKING_OVERVIEW';
const REPORTS_ROUND = 'REPORTS_ROUND';
const REPORTS_STORAGE365_PAYOUTS = 'REPORTS_STORAGE365_PAYOUTS';
const REPORTS_PAYMENT_PROVIDER_TRANSACTION_SUMMARY = 'REPORTS_PAYMENT_PROVIDER_TRANSACTION_SUMMARY';
const REPORTS_STORAGE_STATISTICS = 'REPORTS_STORAGE_STATISTICS';
const REPORTS_STORAGE_SITE_CAPACITY_UTILIZATION_TIMELINE = 'REPORTS_STORAGE_SITE_CAPACITY_UTILIZATION_TIMELINE';
const REPORTS_CAPACITY_UTILIZATION_PER_STORAGE_SITE = 'REPORTS_CAPACITY_UTILIZATION_PER_STORAGE_SITE';
const REPORTS_TAKEOVER_TENANTS = 'REPORTS_TAKEOVER_TENANTS';
const REPORTS_PREGENERATED_FETCH = 'REPORTS_PREGENERATED_FETCH';

export const getEarningsReport = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_EARNINGS, mediaType),
        endpoint: `/api/reports/earnings?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getNewActorsReport = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_NEW_ACTORS, mediaType),
        endpoint: `/api/reports/newActors?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getKpisReport = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_KPIS, mediaType),
        endpoint: `/api/reports/kpis?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getBookingBoundariesReport = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_BOOKING_BOUNDARIES, mediaType),
        endpoint: `/api/reports/bookingBoundaries?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getTransactionsReport = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_TRANSACTIONS, mediaType),
        endpoint: `/api/reports/transactions?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getBookingOverviewReport = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_BOOKING_OVERVIEW, mediaType),
        endpoint: `/api/reports/bookingOverview?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getRoundReport = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_ROUND, mediaType),
        endpoint: `/api/reports/round?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getStorage365PayoutReport = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_STORAGE365_PAYOUTS, mediaType),
        endpoint: `/api/reports/storage365Payouts?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getPaymentProviderTransactionSummary = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_PAYMENT_PROVIDER_TRANSACTION_SUMMARY, mediaType),
        endpoint: `/api/reports/paymentProviderTransactionSummary?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getStorageStatistics = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_STORAGE_STATISTICS, mediaType),
        endpoint: `/api/reports/storageStatistics?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getCapacityUtilizationPerStorageSite = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_CAPACITY_UTILIZATION_PER_STORAGE_SITE, mediaType),
        endpoint: `/api/reports/capacityUtilizationPerStorageSite?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getStorageSiteCapacityUtilizationTimeline = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_STORAGE_SITE_CAPACITY_UTILIZATION_TIMELINE, mediaType),
        endpoint: `/api/reports/storageSiteCapacityUtilizationTimeline?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getTakeoverTenants = (parameters, mediaType) => ({
    [RSAA]: {
        types: createRsaaOrDownloadFileTypes(REPORTS_TAKEOVER_TENANTS, mediaType),
        endpoint: `/api/reports/takeoverTenants/excel?${queryString.stringify(parameters)}`,
        headers: createHeaders(false, mediaType),
        method: 'GET'
    }
});

export const getPregeneratedReport = guid => ({
    [RSAA]: {
        types: createRsaaTypes(REPORTS_PREGENERATED_FETCH),
        endpoint: `/api/reports/pregenerated/${guid}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});
